import React from 'react';
import { Box, ButtonV2, Flex, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

interface EmptyStateProps
  extends Readonly<{
    title: string;
    imageSrc: string;
    subtitle: string;
    buttonText: string;
    imageAltText: string;
    onButtonClick: () => void;
    children?: React.ReactNode;
  }> {}

export const EmptyState = ({ imageSrc, title, subtitle, buttonText, onButtonClick, children, imageAltText }: EmptyStateProps) => {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      width="100%"
      gap={5}
      textAlign="center"
      paddingX={{ _: 6, sm2: 9 }}
      paddingY={6}
      height={'100%'}
      flexGrow={1}
    >
      <Box
        as={'img'}
        alt={imageAltText}
        src={imageSrc}
        width={'100%'}
      />
      <Box>
        <TextV2 typographyVariant={'hed4'}>{title}</TextV2>
        <TextV2
          typographyVariant={'body1'}
          color={'mono10'}
          marginTop={4}
        >
          {subtitle}
        </TextV2>
      </Box>
      <Box
        marginTop={2}
        marginBottom={3}
      >
        <ButtonV2
          intent="newPrimary"
          shape="rounded"
          minWidth={pxToRem(242)}
          onClick={onButtonClick}
        >
          {buttonText}
        </ButtonV2>
      </Box>
      {children}
    </Flex>
  );
};
